import React from 'react';
import { i18n } from '@shared/util/i18n';
import { PressableTextRow } from './PressableTextRow';

export interface ArchiveRowProps {
  disabled: boolean;
  onArchive: (node: React.Component) => any;
}

export function ArchiveRow({ disabled, onArchive }: ArchiveRowProps) {
  return (
    <PressableTextRow
      text={i18n('common.archive')}
      enabled={!disabled}
      leftIcon={'archive-box'}
      rightIcon={disabled ? 'lock' : null}
      onPress={onArchive}
    />
  );
}
